export default "__VITE_ASSET__ByjIsl28__"